import { render, staticRenderFns } from "./AudioComponent.vue?vue&type=template&id=2720d586&scoped=true&"
import script from "./AudioComponent.vue?vue&type=script&lang=js&"
export * from "./AudioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720d586",
  null
  
)

export default component.exports